import React from "react";

export const LoginButton = ({ onClick, validateForm, type }) => {
  return (
    <button
      style={{ width: "100%" }}
      onClick={onClick ? onClick : undefined}
      type={type ? type : undefined}
      className={
        validateForm()
          ? "btn btn-primary form-group"
          : "btn btn-secondary form-group"
      }
      disabled={!validateForm()}
    >
      Login
    </button>
  );
};
